import * as Data$dDate from "../Data.Date/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Restaumatic$dCalendar$dTypes$dAvailability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dMenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
const withPromotionId = v => Data$dTuple.$Tuple(v.promotionId, v);
const toEnginePromotion = p => (
  {
    promotionId: Data$dRecord.unsafeGet("promotionId")(p),
    promotionType: Data$dRecord.unsafeGet("promotionType")(p),
    conditions: Data$dRecord.unsafeGet("conditions")(p),
    prize: Data$dRecord.unsafeGet("prize")(p),
    combineTo: Data$dRecord.unsafeGet("combineTo")(p),
    autoAssignable: Data$dRecord.unsafeGet("enableAutoselect")(p)
  }
);
const isCouponPromotion = v => {
  if (v.promotionType.tag === "Standard") { return false; }
  if (v.promotionType.tag === "InformationOnly") { return false; }
  return v.promotionType.tag === "RequiresCoupon";
};
const isAvailableAt = localDateTime => consumers => v => Restaumatic$dCalendar$dTypes$dAvailability.eqAvailabilityStatus.eq(Restaumatic$dCalendar$dTypes$dAvailability.availabilityStatus(v.availability)(localDateTime))(Restaumatic$dCalendar$dTypes$dAvailability.Available) && !(
  Data$dDate.ordDate.compare(localDateTime._1)(v.start).tag === "LT"
) && !(Data$dDate.ordDate.compare(localDateTime._1)(v.finish).tag === "GT") && !(
  Data$dMap$dInternal.unsafeIntersectionWith(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer.compare, Data$dFunction.const, v.enabledMenuConsumers, consumers).tag === "Leaf"
);
export {isAvailableAt, isCouponPromotion, toEnginePromotion, withPromotionId};
